import { useCallback, useRef, useState } from "react";

export function getPersonInitials(
  firstName?: string | null,
  lastName?: string | null,
) {
  const initials = [firstName, lastName]
    .map((part) => part?.trim().charAt(0))
    .filter(Boolean)
    .join("");

  return initials || "?";
}

export function useHorizontalScrollState() {
  const [isScrolledX, setIsScrolledX] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = useCallback(() => {
    setIsScrolledX((scrollRef.current?.scrollLeft ?? 0) > 0);
  }, []);

  return { scrollRef, isScrolledX, handleScroll };
}
